// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bc5db812","977":"1208f6be"}[chunkId] + ".chunk.js";
};